<script setup lang="ts">
    const props = defineProps<{
        id: string;
        label: string;
        modelValue: boolean;
    }>();

    const emit = defineEmits(['update:modelValue']);

    const toggle = () => {
        emit('update:modelValue', !props.modelValue);
    };
</script>

<template>
    <div>
        <input
            :id="props.id"
            :checked="props.modelValue"
            type="checkbox"
            @click="toggle"
        />
        <label
            tabindex="0"
            role="button"
            :aria-pressed="props.modelValue"
            :for="props.id"
            @keydown.space.prevent="toggle"
            >{{ props.label }}</label
        >
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/filter/preview-filter.scss';
</style>
